import { SpendAndSaveCoupons } from "modules/coupons";

const SpendAndSaveCouponsPage = () => {
  return <SpendAndSaveCoupons />;
};

export default SpendAndSaveCouponsPage;
